export default __webpack_public_path__ + "static/media/ChickenMasala.4648f863.png";